<script>
import html2canvas from "html2canvas";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    VueQRCodeComponent,
  },
  props: {
    title: {
      type: String,
    },
    fullName: {
      type: String,
    },
    date: {
      type: String,
    },
    Id: {
      type: String,
    },
    qrCodeContent: {
      type: String,
    },
    artists: {
      type: Array,
    }
  },
  methods: {
    // print card
    async download() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
};
</script>

<template>
  <div class="text-center print-cover">
    <div class="card-print con-print text-center" ref="printcontent">
      <div class="header">
        <h5>مهرجان قادة النصر</h5>
        <p><strong>الاسم : </strong> {{ fullName }}</p>
        <p><strong>تاريخ التقديم : </strong> {{ date }}</p>
        <p><strong>رقم الاستمارة : </strong> {{ Id }}</p>
      </div>
      <div class="artwork text-center">
        <h5>الاعمال الفنية الخاصة بك</h5>
        <hr />
        <ol class="centered-list mb-0">
          <li v-for="artist in artists" :key="artist.id">
            <p>
              <span>{{ artist.sub.main.name_ar }}</span>
              <i class="mdi mdi-chevron-left"></i>
              <span>{{ artist.artwork_name }}</span>
            </p>
          </li>
        </ol>
      </div>
      <VueQRCodeComponent class="qr-code" :text="qrCodeContent"></VueQRCodeComponent>
    </div>
    <button type="button" id="btn3" @click="download" class="btn btn-save-qr btn-sm mt-3">
      حفظ وصل التسجيل
    </button>
  </div>
</template>
